import { CONTEXT_LOG_SUBJECT_TYPES, ContextLogCommitParameterResponse, ContextLogCreateParameterResponse, ContextLogCreateRequest, ContextLogCreateResponse, ContextLogReadAllResponse } from "@/types/contextLogTypes";
import { Client } from "./client";
import { FusaReply } from "@/types/replyTypes";

export class ContextLogController {
  client: Client;

  constructor() {
    this.client = new Client();
  }

  public async create(req: ContextLogCreateRequest): Promise<ContextLogCreateResponse> {
    return this.client.create('/api/context-logs', req);
  }

  public async deleteContextLogAndResetParameter(contextLogId: string): Promise<FusaReply> {
    return this.client.delete(`/api/context-logs/deleteContextLogAndResetParameter/${contextLogId}`);
  }

  public async deleteContextLogForSubject(subjectId: string, subjectType: CONTEXT_LOG_SUBJECT_TYPES): Promise<FusaReply> {
    return this.client.delete(`/api/context-logs/deleteContextLogsForSubject/${subjectId}/${subjectType}`);
  }

  public async deleteContextLog(contextLogId: string): Promise<FusaReply> {
    return this.client.delete(`/api/context-logs/${contextLogId}`);
  }

  public async commitParameterContextLog(contextLogId: string, note: string, userEmail: string): Promise<ContextLogCommitParameterResponse> {
    return this.client.create(`/api/context-logs/commitParameterContextLog`, { contextLogId, note, userEmail });
  }

  public async createParameterContextLog(parameterId: string): Promise<ContextLogCreateParameterResponse> {
    return this.client.create(`/api/context-logs/createParameterContextLog/${parameterId}`, {});
  }

  public async readContextLogs(rootId: string): Promise<ContextLogReadAllResponse> {
    return this.client.read(`/api/context-logs/readContextLogs/${rootId}`);
  }
}
